<form class="drop-padding" [class.compactCreate]="compact" (ngSubmit)="create()" [formGroup]="createForm">
  <mat-form-field class="productDescriptionField" [appearance]="compact ? 'outline' : 'legacy'">
    <mat-label>Название</mat-label>
    <input matInput formControlName="description" type="text" />
  </mat-form-field>
  <app-brand-selector [control]="createForm.controls.brand"></app-brand-selector>
  <mat-form-field [appearance]="compact ? 'outline' : 'legacy'">
    <mat-label>Артикул</mat-label>
    <input matInput formControlName="article" type="text" />
  </mat-form-field>
  <mat-form-field [appearance]="compact ? 'outline' : 'legacy'">
    <mat-label>Штрих-код</mat-label>
    <input matInput formControlName="barcode" type="text" />
  </mat-form-field>
  <mat-form-field [appearance]="compact ? 'outline' : 'legacy'">
    <mat-label>Описание</mat-label>
    <textarea rows="2" matInput formControlName="descriptionLong"></textarea>
  </mat-form-field>
  <button mat-raised-button color="primary" [disabled]="loading || createForm.invalid" type="submit">{{ loading ? 'Создание…' : submitLabel }}</button>
</form>
